<!--
 * @Description: 
 * @Author: pliybird
 * @Date: 2023-06-12 10:20:34
 * @LastEditTime: 2023-07-19 14:54:49
 * @LastEditors: pliybird
 * @filePath: Do not edit
-->
<!--
 * @Description: 为什么选择我们Card
-->
<template>
  <div class="why_choose_us">
    <section class="choose_us why_choose_us rn-section-gap">
      <div class="go_choose_height">
        <div class="container">
          <SectionTitle
            :title="$t('about_us.why_choose_us.title')"
            description="WHY CHOOSE US"
            textAlign="center"
          />
          <div class="go_choose_card">
            <div
              class="choose_card col-lg-6 col-md-6 col-sm-12 col-12"
              v-for="item in chooseList"
              :key="item.id"
            >
              <div class="choose_card_content">
                <div class="choose_card_image why_choose_us card_image">
                  <div>
                    <img :src="item.img" />
                  </div>
                </div>
                <div class="choose_content">
                  <div class="choose_content_title why_choose_us first_title">
                    {{ item.title }}
                  </div>
                  <div class="choose_ul why_choose_us ul_list">
                    <ul v-if="item.mainPoint">
                      <li v-for="ite in item.mainPoint" :key="ite.id">
                        {{ ite.title }}
                      </li>
                    </ul>
                    <div class="choose_desc why_choose_us second_title">
                      {{ item.desc }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="choose_card_img">
              <img v-if="$i18n.locale === 'zh_CN'" src="@/assets/images/whyChooseUs/choose-img.png" />
              <img v-if="$i18n.locale === 'en_US'" src="@/assets/images/whyChooseUs/choose-img_en.png" />
              <img v-if="$i18n.locale === 'ja_JP'" src="@/assets/images/whyChooseUs/choose-img_ja.png" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import SectionTitle from '@/components/elements/sectionTitle/SectionTitle'

export default {
  name: 'whyChooseUs',
  components: {
    SectionTitle
  },
  data () {
    return {
      chooseList: [
        {
          id: 1, img: require('@/assets/images/whyChooseUs/choose-01.png'), title: this.$t('about_us.why_choose_us.tab01.title'),
          desc: this.$t('about_us.why_choose_us.tab01.description04'),
          mainPoint: [{ id: 1, title: this.$t('about_us.why_choose_us.tab01.description01') }, { id: 2, title: this.$t('about_us.why_choose_us.tab01.description02') }, { id: 3, title: this.$t('about_us.why_choose_us.tab01.description03') }]
        },
        {
          id: 2, img: require('@/assets/images/whyChooseUs/choose-02.png'), title: this.$t('about_us.why_choose_us.tab02.title'),
          desc: this.$t('about_us.why_choose_us.tab02.description')
        },
        {
          id: 3, img: require('@/assets/images/whyChooseUs/choose-03.png'), title: this.$t('about_us.why_choose_us.tab03.title'),
          desc: this.$t('about_us.why_choose_us.tab03.description')
        },
        {
          id: 4, img: require('@/assets/images/whyChooseUs/choose-04.png'), title: this.$t('about_us.why_choose_us.tab04.title'),
          desc: this.$t('about_us.why_choose_us.tab04.description')
        },
      ],
    }
  },
  methods: {
   
  }
}
</script>